/** Formateo para la interfaz. En español, que es el idioma del panel. */

const relative = new Intl.RelativeTimeFormat('es', { numeric: 'auto' });

const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['second', 60],
  ['minute', 60],
  ['hour', 24],
  ['day', 30],
  ['month', 12],
  ['year', Number.POSITIVE_INFINITY],
];

export const timeAgo = (value: Date | string | null | undefined): string => {
  if (!value) return 'nunca';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  let delta = (date.getTime() - Date.now()) / 1000;
  for (const [unit, step] of UNITS) {
    if (Math.abs(delta) < step) return relative.format(Math.round(delta), unit);
    delta /= step;
  }
  return date.toLocaleDateString('es');
};

export const bytes = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = value;
  let unit = 0;
  while (size >= 1024 && unit < units.length - 1) {
    size /= 1024;
    unit += 1;
  }
  return `${size.toFixed(size >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
};

export const percent = (value: number | undefined | null): string =>
  value === undefined || value === null ? '—' : `${Math.round(value)} %`;

/**
 * Costo mensual fijo de un nodo, guardado en centavos (evita redondeos de
 * coma flotante). USD como moneda de referencia: los providers de VPS que
 * maneja el equipo facturan en esa moneda; si el tenant llegara a necesitar
 * otra, esto necesita un campo de moneda, no solo cambiar el formateador.
 */
const money = new Intl.NumberFormat('es', { style: 'currency', currency: 'USD' });
export const cost = (cents: number | undefined | null): string =>
  cents === undefined || cents === null ? '—' : money.format(cents / 100);

export const uptime = (seconds: number | undefined | null): string => {
  if (seconds === undefined || seconds === null) return '—';
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3_600);
  if (days > 0) return `${days} d ${hours} h`;
  const minutes = Math.floor((seconds % 3_600) / 60);
  return `${hours} h ${minutes} min`;
};
